import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { CatalogItemRow } from "../catalogItems.types";

export const NameCell = memo(function NameCell({
    row,
}: CellContext<ViewTableFeatures, CatalogItemRow, unknown>) {
    return <ViewTableCell>{row.original.name}</ViewTableCell>;
});
